const acrAlertEN = {
    "form": {
        "modal": {
            "releaseCopyrightDeclaration": {
                "header": "Release Copyright Declaration",
                "body": {
                    "description": "There is a Copyright Alert for this Release. The flagged tracks/content is as follows:",
                    "table": {
                        "column": {
                            "trackName": "Track Name",
                            "type": "Type",
                            "title": "Title",
                            "artists": "Artists",
                            "album": "Album",
                            "label": "Label",
                            "releaseDate": "Release Date",
                            "releaseYear": "Release Year"
                        },
                    },
                    "label": {
                        "music": "Music",
                        "cover": "Cover",
                        "sourceOne": "Source One",
                        "sourceTwo": "Source Two",
                        "releaseLicense": "Release License",
                        "proofOfPurchase": "Proof of Purchase (Sample Packs)",
                        "signDeclaration": "Kindly sign the declaration in order to proceed further.",
                        "cancelRelease": "I want to cancel this release.",
                        "approveRelease": "I want to approve this release and understand and fully accept the legal ramifications of this action.",
                        "approveReleaseAllStores": "I want to approve this release to ALL stores; found results are 100% identical with our artist and the content belongs to our artist. We understand and fully accept the legal ramifications of this action.",
                        "approveReleaseAllStoresCover": "I want to approve this release to ALL stores; this is a COVER release for which I have purchased LICENSE.",
                        "legitimateMusic": "My music is legitimate and does not infringe on anyone's rights. I used legally purchased sample packs.",
                        "disagreeWithResults": "I completely disagree with the results presented. My music is absolutely clean. I am requesting a revision."
                    },
                    "help_text": {
                        "releaseLicense": "Please upload the Release License",
                        "legitimateMusic": "Please note that you are required to upload the original invoice as proof of purchase for the sample pack. Please note that any attempt to circumvent or commit fraud will be subject to a penalty fee.",
                        "proofOfPurchaseFileUpload": "Please upload the Proof of Purchase (Sample Packs)",
                        "disagreeWithResults": "By selecting this option, you acknowledge the potential charge of € 100 to your account in the event that a revision reveals matches. The revision tools we use shall be the final decision-maker; anything matching other songs with a similarity above 5% shall be deemed illegitimate content.  Please note that if you abuse, misrepresent, or use this opt-in in a false manner, we reserve the right to terminate your account immediately without refund."
                    },
                },
                "button": {
                    "submit": "Submit",
                    "cancel": "Cancel"
                }
            },
            "confirmRejection": {
                "header": "Confirm Rejection",
                "body": "By rejecting this release, your release will go OFFLINE and you’d have to adjust it before re-submitting it for distribution again. Are you sure you want to do this?",
                "bodyReDelivery": "By doing this action your release will move to Re-Delivery Editing status. If edits included both audio and metadata changes, in this case only the audio changes are reverted, and you would need to submit your editing again. If your update was audio-only, your release returns to Distributed status instead. Are you sure you want to continue?",
                "button": {
                    "yes": "Yes",
                    "no": "No"
                }
            }
        },
        "message": {
            "releaseDistributionCancelled": "You have cancelled the distribution of the release. If you change your mind, you’d need to make changes to the audio file and re-submit for distribution.",
            "releaseHasCopyrightAlert": "Release {{releaseName}} has a Copyright Alert. Kindly sign the <4>Declaration</4>to proceed further.",
            "submitEditingMetadataNote": "Audio file was rejected due to the scan, however because metadata was also changed, you would need to click Submit Editing in order to proceed further.",
            "submitEditingMetadataAdminNote": "The audio file that you want to change has been rejected by the admin. The rest of the metadata can be submitted for editing.",
            "admin_pending": "Your declaration is pending admin review for further action.",
            "admin_approved": "Your request to distribute your release has been approved by our admin team. The release has been successfully verified. We appreciate your diligence in ensuring accuracy and compliance. The release will proceed to all stores as planned. Thank you for your attention to detail and adherence to our standards.",
            "admin_rejected": "Your request to distribute your release has been rejected. After careful review, the request does not meet our approval requirements. We recommend re-evaluating the content and ensuring all conditions and legal implications are addressed. Thank you for your understanding and cooperation.",
            "button": {
                "yes": "Yes",
                "no": "No"
            }
        }
    }
};

export default acrAlertEN;